import React, {useEffect, useState} from "react"
import { Link } from "gatsby"

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [openSubMenuCompany, setOpenSubMenuCompany] = useState(false);
  const [openSubMenuAlliance, setOpenSubMenuAlliance] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleOnMenu = (fn, state) => {
    fn(!state)
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`header-wrap ${isScrolled ? 'header-shadow' : ''}`}>
      <header className="header">
        <div className="header-logo">
          <Link to="/">
            <img
              src="https://stgokulabweb.blob.core.windows.net/images/okulab_logo.png"
              alt="OKULAB"
              loading="lazy"
            />
          </Link>
        </div>

        <nav className={`${openMenu ? "active" : ""} header-nav`}>
          <ul className="header-menu">
            <li>
              <Link to="/">ホーム</Link>
            </li>
            <li>
              <div className="op-none pc">会社情報</div>
              <div
                  className={`${
                      openSubMenuCompany ? "is-open" : "is-close"
                  } op-none sp drop-down`}
                  onClick={() => handleOnMenu(setOpenSubMenuCompany, openSubMenuCompany)}
                  onKeyDown={() => handleOnMenu(setOpenSubMenuCompany, openSubMenuCompany)}
                  role="button"
                  tabIndex={0}
              >
                会社情報
              </div>
              <div className={`${
                  openSubMenuCompany ? "is-open" : "is-close"
              } sub-menu-wrap`}>
                <ul
                    className={`${
                        openSubMenuCompany ? "is-open" : "is-close"
                    } sub-menu drop-down-menu`}
                >
                  <li>
                    <Link to="/company/mission">ミッション</Link>
                  </li>
                  <li>
                    <Link to="/company/message">メッセージ</Link>
                  </li>
                  <li>
                    <Link to="/company/profile">会社概要</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div className="op-none pc">サービス</div>
              <div
                className={`${
                    openSubMenu ? "is-open" : "is-close"
                } op-none sp drop-down`}
                onClick={() => handleOnMenu(setOpenSubMenu, openSubMenu)}
                onKeyDown={() => handleOnMenu(setOpenSubMenu, openSubMenu)}
                role="button"
                tabIndex={0}
              >
                サービス
              </div>
              <div className={`${
                  openSubMenu ? "is-open" : "is-close"
              } sub-menu-wrap`}>
                <ul
                  className={`${
                    openSubMenu ? "is-open" : "is-close"
                  } sub-menu drop-down-menu`}
                >
                  <li>
                    <Link to="/services/fc">フランチャイズ事業</Link>
                  </li>
                  <li>
                    <Link to="/services/startup">コインランドリー出店支援</Link>
                  </li>
                  <li>
                    <Link to="/services/machine">ランドリー機器販売</Link>
                  </li>
                  <li>
                    <Link to="/services/support">コインランドリー運営支援</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div className="op-none pc">アライアンス</div>
              <div
                  className={`${
                      openSubMenuAlliance ? "is-open" : "is-close"
                  } op-none sp drop-down`}
                  onClick={() => handleOnMenu(setOpenSubMenuAlliance, openSubMenuAlliance)}
                  onKeyDown={() => handleOnMenu(setOpenSubMenuAlliance, openSubMenuAlliance)}
                  role="button"
                  tabIndex={0}
              >
                アライアンス
              </div>
              <div className={`${
                  openSubMenuAlliance ? "is-open" : "is-close"
              } sub-menu-wrap`}>
                <ul
                    className={`${
                        openSubMenuAlliance ? "is-open" : "is-close"
                    } sub-menu drop-down-menu`}
                >
                  <li>
                    <Link to="/alliance/property">物件募集</Link>
                  </li>
                  <li>
                    <Link to="/alliance/partner">ビジネスパートナー募集</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <Link to="/recruit">採用情報</Link>
            </li>
            <li>
              <Link to="/contact">お問い合わせ</Link>
            </li>

            <li>
              <Link to="/news">ニュース</Link>
            </li>
          </ul>

          {/*/.menu*/}
        </nav>

        <div
          className="sp"
          onClick={() => handleOnMenu(setOpenMenu, openMenu)}
          onKeyDown={() => handleOnMenu(setOpenMenu, openMenu)}
          role="button"
          tabIndex={0}
        >
          <div
            className={`${openMenu ? "open" : "hide"} toggle-btn-style`}
          ></div>
        </div>
      </header>
    </div>
  )
}
export default Header
